import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VueResource from 'vue-resource'
import store from './store'

Vue.use(VueResource)
Vue.config.productionTip = false
Vue.http.options.root = process.env.VUE_APP_API_URL
// Vue.http.options.root = '/api/'
//Vue.http.options.root = 'http://showcase.nashepole.com.ua/api/' // dev

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
 